export enum ProductType {
    IvrBundleSession = 1,
    ImBundleTopUp = 2,
    ImPaygSession = 3,
    ImPaygTopUp = 4,
    ImBundleSession = 5,
    IvrPaygSession = 6,
    GeneralTopUp = 7,
    IvrBundleTopUp = 8,
    MinutesTopUp = 101
}
